<template>
  <section v-show="points.length" class="festivals">
    <h3 v-if="otherName">
      <translate :tt="{ otherName }">
        Other festivals near {otherName}
      </translate>
    </h3>
    <translate v-else tag="h3"> Local events </translate>
    <ul>
      <li v-for="(festival, index) in points" :key="index">
        <strong>{{ festival.name }}</strong>
        <translate
          v-if="festival.startDate && festival.endDate"
          :tt="{ start: festival.startDate, end: festival.startDate }"
        >
          ({start, puDate, full} &ndash; { end, puDate, full})
        </translate>
        <p v-if="festival.location || festival.distance" class="poi">
          <span class="location">{{ festival.location }}</span>
          <translate
            v-if="festival.distance"
            class="distance"
            :tt="{ distance: getDistance(festival.distance) }"
          >
            {distance, distance, short}
          </translate>
        </p>
      </li>
    </ul>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { NearbyFestivalsAttraction } from '~/apps/campsite-details/types'
import { convertMetersToDistanceObject } from '~/utility/geo/Distance'

@Component
class CampsiteFestivals extends Vue {
  @Prop()
  otherName: string
  @Prop()
  points: NearbyFestivalsAttraction[]

  getDistance(distance: string) {
    return convertMetersToDistanceObject(distance)
  }
}

export default toNative(CampsiteFestivals)
</script>

<style scoped>
.location {
  font-weight: normal;
}
</style>
